<template>
  <v-app light>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <keep-alive :exclude="['MyCVListView', 'UserProfileView']">
      <router-view :key='$route.path'></router-view>
    </keep-alive>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  data () {
    return {
      //
    }
  }
}
</script>



